import gql from 'graphql-tag';

export const REASSIGN_TERRITORIES = gql`
  mutation ReassignTerritories($input: reassignTerritoriesInput) {
    reassignTerritories(input: $input) {
      success
    }
  }
`;
